import React from 'react';

import TextBase from './TextBase';
import { TBoxProps } from '../Box/Box';
import { TColor } from '../../types/TStyleVariables';

type TAction = {
  as?: TBoxProps['as'];
  color?: TColor;
};

const Action = ({ as = 'span', color, ...rest }: TAction) => <TextBase as={as} kind="action" color={color} {...rest} />;

export default Action;
